export const noop: () => void = Function.prototype as any
